<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
          사이트
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WMDS</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Site</a>
          </li>
      </ul>
    </div>
    <quick-setup @refresh="refresh" v-if="is_first" @count="x => this.$parent.$emit('count', x)"></quick-setup>
    <b-tabs v-else v-model="tab_index">
      <b-tab no-body title="사이트">
        <b-row>
          <b-col lg="12" :xl="isLoadPolicy ? 8 : 12">
            <b-card>
              <div slot="header">
                <strong>사이트 정보</strong>
                <span v-if="!add && model.created_at">( 등록일 : {{model.created_at | sdate}})</span>
                <span class="float-right" v-if="!add && model.last_visit">최근 점검일 : {{model.last_visit | sdate}}</span>
                <span class="float-right" v-else> - </span>
              </div>
              <b-row>
                <b-col md="2" v-if="add" style="cursor:pointer">
                  <b-form-group>
                    <label v-b-tooltip.hover title="등록시 점검을 즉시 시작합니다">
                      등록시 시작
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>

                    </label>
                    <br>
                    <c-switch color="info" label size="sm" v-model="model.is_start" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="2" v-else>
                  <b-form-group>
                    <label v-b-tooltip.hover title="사용 상태 활성화 또는 비황성화 상태">
                      상태
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>

                    </label>
                    <br>
                    <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group>
                    <label v-b-tooltip.hover title="자바스크립트의 링크 클릭 이벤트 사용 여부를 설정합니다 사용시 점검 속도가 느려질 수 있습니다">
                      JS 이벤트
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>

                    </label>
                    <br>
                    <c-switch color="info" label size="sm" v-model="model.is_js" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group>
                    <label v-b-tooltip.hover title="로그인 기능 활성화 또는 비황성화 상태">
                      로그인 사용
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>

                    </label>
                    <br>
                    <c-switch color="info" label size="sm" v-model="model.is_login" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="5" v-show="!add && lock">
                  <b-form-group>
                    <label v-b-tooltip.hover title="점검 정책을 지정하십시요 정책은 미리 생성되어 있어야 합니다">
                      정책
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>

                    </label>
                    <p>{{policy.description}}</p>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-show="!lock">
                  <b-form-group>
                    <label for="ph_schedule_type" v-b-tooltip.hover title="점검 정책을 지정하십시요 정책은 미리 생성되어 있어야 합니다">
                      점검 정책
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>

                    </label>
                    <b-form-select v-model="model.policy_id" @change="change($event)" :disabled="lock" ref="policy">
                      <option v-for="item in policy_list" :key="item.id" :value="item.id">{{item.description ? item.description : item.policy.description}}</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label for="ph_username" v-b-tooltip.hover title="사이트를 구분하는 이름을 지정합니다">
                      이름

                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>

                    </label>
                    <b-form-input placeholder="Auto Fill when write FQDN input" type="text" id="ph_name" v-model="model.name" :plaintext="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    FQDN : ex) www.f1security.co.kr : www(host) + f1security.co.kr(domain)
                    <hr>
                    <b-input-group class="text-center">
                      <b-input-group-prepend><b-input-group-text> FQDN </b-input-group-text></b-input-group-prepend>
                      <b-form-input class="text-center border" type="text" ref="fqdn" id="ph_fqdn" placeholder="FQDN (ex : www.company.com)" v-model="model.fqdn" :plaintext="lock" @change="check_fqdn"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <label
                    style="cursor:pointer"
                    v-b-tooltip.hover.hover:title="`확인할 URL 또는 확인할 기본 페이지 또는 확인할 페이지의 URL`"
                  >
                    점검 시작 URL (최대 10)
                    <span class="text-info">
                      <i class="fas fa-question-circle"></i>
                    </span>
                  </label>
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-prepend><b-input-group-text> 시작 URL </b-input-group-text></b-input-group-prepend>
                      <b-form-input id="ph_seed" v-model="v.seed" type="url" placeholder="Full URL, ex) https://f1security.co.kr" @keyup.native.enter="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-addition" variant="primary" @click="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)">추가</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(seed, index) in model.config.seeds" :key="'_seed_'+index"><i class="fa fa-times" @click="remove_seed(seed)" v-show="!lock"></i> {{seed}}</b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label
                      v-b-tooltip.hover.hover:title="`점검 주기를 설정합니다. 사이트에 액세스하는 사람이 적은 시간에 하루에 한 번 이상 확인하는 것이 좋습니다.`"
                      style="cursor:pointer"
                    >
                      점검 일정
                      <span class="text-info">
                        <i class="fa fa-question-circle"></i>
                      </span>
                    </label>
                    <small>최대 :{{max_schedule}}</small>
                    <hr>
                    * <b-badge variant="warning">공지</b-badge>
                    : 사이트 가용성으로 하루 최대 24회 제한될 수 있습니다
                    <hr>
                    <b-input-group>
                      <!-- <b-form-select ref="schedule" id="ph_schedule" v-model="s.h" :options="s.h_opt" :disabled="lock" @change="schedule($event, 'h')"></b-form-select>
                      <b-form-select v-model="s.m" :options="s.m_opt" :disabled="lock" @change="schedule($event, 'm')"></b-form-select> -->
                      <b-form-select v-if="i18n" ref="schedule" id="ph_schedule" v-model="s.h" :options="s.h_opt[i18n]" :disabled="lock" @change="schedule($event, 'h')"></b-form-select>
                      <b-form-select v-if="i18n" v-model="s.m" :options="s.m_opt[i18n]" :disabled="lock" @change="schedule($event, 'm')"></b-form-select>
                      <b-input-group-append>
                        <b-button class="btn-addition" variant="primary" @click="add_schedule" :disabled="lock || (model.schedule.length >= max_schedule)">추가</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(schedule, index) in model.schedule" :key="'_sch_'+index">
                        <i class="fa fa-times" @click="remove_schedule(schedule)" v-if="!lock"></i>
                        ({{ schedule }}) {{ cron_filter(schedule) }}
                      </b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <strong>추가 정보</strong>
              <hr>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <label
                      style="cursor:pointer"
                      for="ph_sub_domain"
                      v-b-tooltip.hover.hover title="동일한 사이트 내에 하위 도메인이 있는 경우 등록합니다 ex) admin.f1security.co.kr"
                    >
                      서브 도메인
                      <span class="text-info">
                        <i class="fas fa-question-circle"></i>
                      </span>
                    </label>
                    <b-input-group>
                      <b-form-input id="ph_sub_domain" v-model="v.sub" type="text" ref="sub_domains" placeholder="Domain" @keyup.native.enter="add_sub" :disabled="lock || (model.config.subs.length >= 100)"></b-form-input>
                      <b-button class="btn-addition" variant="primary" @click="add_sub" :disabled="lock || (model.config.subs.length >= 100)">추가</b-button>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(sub, index) in model.config.subs" :key="'_sub_'+index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_sub(sub)"></i> {{sub}}</b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <label
                      style="cursor:pointer"
                      for="ph_prevent"
                      v-b-tooltip.hover.hover title="예외를 처리할 경로를 지정합니다(부분 지정 불가). ex)/admin/download">
                      예외 경로
                      <span class="text-info">
                        <i class="fas fa-question-circle"></i>

                      </span>
                    </label>
                    <b-input-group>
                      <b-form-input id="ph_prevent" v-model="v.prevent" ref="prevent" type="text" placeholder="subroutine path" @keyup.native.enter="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-additions" variant="primary" @click="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)">추가</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <b-list-group>
                      <b-list-group-item v-for="(prevent, index) in model.config.prevents" :key="'_prevent_'+index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_prevent(prevent)"></i> {{prevent}}</b-list-group-item>
                    </b-list-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label
                      style="cursor:pointer"
                      for="ph_prevent"
                      v-b-tooltip.hover.hover title="정규식으로 에외처리할 단어를 입력합니다(부분 처리 가능) ex) (edit|remove)">
                      정규식 예외 처리
                      <span class="text-info">
                        <i class="fas fa-question-circle"></i>

                      </span>
                    </label>
                    <b-form-input class="text-center border" v-model="model.regex" placeholder="정규식 포맷 사용" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- <hr>
              <template v-if="lock">
                <template v-if="model.is_del">
                  <b-button size="sm" variant="success" @click="revive"> Recover </b-button>
                  <span>Recover</span>
                </template>
                <template v-else>
                  <b-button size="sm" variant="primary" @click="edit" class="btn-add"> Edit </b-button>
                  <b-button size="sm" variant="danger" @click="del_confirm = true"> Remove </b-button>
                </template>
              </template>
              <template v-else>
                <b-button size="sm" variant="success" @click="() => model.id ? save() : modal_charge_agree = true"> Save </b-button>
                <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> Cancel </b-button>
              </template>
              <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>  -->
            </b-card>
          </b-col>
          <!-- </b-row> -->
          <!-- </b-col> -->
          <!-- policy start -->
          <b-col lg="12" xl="4" v-if="isLoadPolicy">
            <b-card>
              <div slot="header">
                <strong>정책</strong>
                <small class="float-right">읽기 전용 정보</small>
              </div>
              <b-row class="text-center">
                <b-col md="12">
                  <span block class="h5">{{ isLoadPolicy ?  policy.description : '-'}}</span>
                  <hr>
                  <small>
                    이 페이지는 정책 정보만 표시하며, 정책 편집 페이지에서 변경할 수 있습니다.
                  </small>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col md="12">
                  <b-form-group v-b-tooltip.hover.hover :title="`첫 페이지에서 다음 페이지로 링크를 이동(경로)하여 확인할지 여부를 입력합니다. 첫 페이지에서 다음 페이지로 링크를 이동(경로)하여 확인할지 여부를 입력합니다. 1-100 범위 내에서 지정할 수 있습니다`">
                    <b-input-group-prepend><b-input-group-text> 최대 경로 깊이 &nbsp;
                                          <span class="text-info">
                                            <i style="cursor:pointer" class="fas fa-question-circle"></i>
                                          </span>
                    </b-input-group-text></b-input-group-prepend>
                    <b-form-input :disabled="true" class="text-center border" type="number" id="ph_depth" :min="1" :max="100" v-model="policy.depth" :plaintext="true"></b-form-input>
                </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    페이지 내에서 탐색하려면 최대 하위 링크를 입력합니다.
                    초과 링크는 않으며 일반적으로 한 페이지에 너무 많은 링크가 있는 경우, 다른 페이지로 이동하기 전에 최대 탐색 페이지에 도달하여 균형 있게 점검되지 못할 수 있습니다.
                    1-1,000 범위 내에서 지정할 수 있습니다`"
                  >
                      <b-input-group-prepend><b-input-group-text> 서브 페이지 링크 &nbsp;
                                            <span class="text-info">
                                              <i style="cursor:pointer" class="fas fa-question-circle"></i>
                                            </span>
                      </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1" :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    검사 사이트에서 확인할 총 페이지 수입니다.
                    입력한 번호에 도달하면 검사를 종료합니다.
                    해당 설정은 1 부터 라이센스 제한 범위 내에서 자유롭게 지정할 수 있습니다.`"
                  >
                      <b-input-group-prepend><b-input-group-text> 최대 탐색 페이지 &nbsp;
                                            <span class="text-info">
                                              <i style="cursor:pointer" class="fas fa-question-circle"></i>
                                            </span>
                      </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_limit" :min="10" :max="50000" v-model="policy.limit" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    페이지 로딩 대기 시간은 1~30 범위 내에서 지정할 수 있습니다`"
                  >
                      <b-input-group-prepend><b-input-group-text> 타임아웃(초) &nbsp;
                                            <span class="text-info">
                                              <i style="cursor:pointer" class="fas fa-question-circle"></i>
                                            </span>
                      </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_timeout" :min="1" :max="30" v-model="policy.timeout" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    v-b-tooltip.hover.hover
                    :title="`
                    새 페이지로 이동하기 전에 기다려야 할 시간입니다. 1 ~ 10,000 범위 내에서 지정할 수 있습니다`"
                  >
                      <b-input-group-prepend><b-input-group-text> 점검 속도(밀리초) &nbsp;
                                            <span class="text-info">
                                              <i style="cursor:pointer" class="fas fa-question-circle"></i>
                                            </span>
                      </b-input-group-text></b-input-group-prepend>
                      <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="0" :max="10000" v-model="policy.delay" :plaintext="true"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <template>
                <b-button class="btn-add" block size="sm" variant="success" @click="policy_manage"> 관리 </b-button>
              </template>
            </b-card>
            <!-- result start -->
            <b-card>
              <div slot="header" class="text-center">
                <strong v-if="result.page_count > 0">최근 점검결과 확인</strong>
                <strong v-else>최근 점검 결과가 없습니다 </strong>
              </div>
              <template>
                <b-button :disabled="!(result.page_count > 0)" block size="sm" variant="warning" @click="confirm_result = true"> 확인 </b-button>
              </template>
            </b-card>
          </b-col>
        </b-row>
        <hr>
        <template v-if="lock">
          <template v-if="model.is_del">
            <b-button class="btn-add" size="sm" variant="success" @click="revive"> 복구 </b-button>
            <span>복구</span>
          </template>
          <template v-else>
            <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 수정 </b-button>
            <b-button size="sm" variant="danger" @click="del_confirm = true"> 삭제 </b-button>
          </template>
        </template>
        <template v-else>
          <b-button size="sm" class="btn-add" variant="success" @click="() => model.id ? save() : modal_charge_agree = true"> 저장 </b-button>
          <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> 취소 </b-button>
        </template>
        <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>
      </b-card>
    </b-tab>
    <b-tab no-body title="로그인 점검" :disabled="!model.is_login">
      <vcl-facebook v-if="loading"></vcl-facebook>
      <b-card v-else>
        <template slot="header">
          <label v-b-tooltip.hover title="로그인이 필요한 페이지 점검시 계정 정보를 입력합니다">
            <strong>WMDS 로그인 설정</strong>
                      <span class="text-info">
                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>

          </label>
        </template>
        <b-row>
          <b-col lg="11" xl="11">
            <b-form-group>
              <b-input-group class="text-center">
                <b-input-group-prepend><b-input-group-text> 로그인 페이지 </b-input-group-text></b-input-group-prepend>
                <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" ref="login_url" id="login_url" placeholder="Login URL : ex) http://www.f1security.co.kr/login.do" v-model="model.login_url" :plaintext="lock" @change="check_login"></b-form-input>
                <!-- <b-button class="float-right mr-2" size="sm" variant="primary" @click="test" :disabled="lock"> 1. 사이트 정보 수집 </b-button> -->
                <!-- <b-button class="float-right mr-2" size="sm" variant="primary" @click="popup" :disabled="lock"> 2. 계정 정보 수집 </b-button> -->
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="iframe" v-b-tooltip.hover title="사이트가 iframe을 사용하는지 설정합니다">
              <c-switch color="info" label size="sm" v-model="opt_login.is_iframe" :disabled="lock" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-input-group class="text-center">
                <b-button class="m-2" size="sm" variant="primary" @click="test" :disabled="lock"> 1. 사이트 정보 수집 </b-button>
                  <p class="m-2">(</p>
                  <b-button class="m-2" size="sm" variant="primary" @click="popup(0)" :disabled="lock"> 2. 계정 정보 수집 (javascript, css 포함) </b-button>
                  <p class="m-2">or</p>
                  <b-button class="m-2" size="sm" variant="primary" @click="popup(1)" :disabled="lock"> 2. 계정 정보 수집 (javascript, css 제외) </b-button>
                  <p class="m-2">)</p>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col>
            <span class="text-danger">* 로그인 기능을 사용하여 점검시 사이트 예외 경로를 추가하거나 정규식 예외 기능으로 특정 기능(삭제, 추가 등)을 제외합니다</span>
            <br>
            <span class="text-danger">* 로그인 정보 수집을 정상적으로 완료하지 못할 경우 수동으로 입력해주세요.</span>
            <br>
            <span class="text-danger">* 새로운 계정 정보 수집시, 초기화를 권장합니다</span>
            <hr>
            <strong>
              안내 문구 : {{ !lock ? (opt_login_msg || '-') : '-' }}
            </strong>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <b-button block class="m-2" size="sm" variant="warning" @click="() => { opt_login.username = ''; opt_login.password = ''; opt_login.el_password = ''; opt_login.el_username = ''; opt_login.el_submit = ''; }" :disabled="lock"> 초기화 </b-button>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend>
                    <b-input-group-text> 아이디 태그의 고유 문자열 </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.el_username" :state="(opt_login.el_username.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> 아이디 </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.username" :state="(opt_login.username.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> 비밀번호 태그의 고유 문자열 </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.el_password" :state="(opt_login.el_password.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group>
                  <b-input-group-prepend style="display:inline-block;text-align:left; float:left;">
                    <b-input-group-text> 비밀번호 </b-input-group-text>
                  </b-input-group-prepend>
                  <b-input-group-prepend style="display:inline-block;text-align:right;float:right;">
                    <b-checkbox :disabled="lock" class="float-right" v-model="opt_login.is_show">보기</b-checkbox>
                  </b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" :type="opt_login.is_show ? 'text' : 'password'" v-model="opt_login.password" :state="(opt_login.password.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> 로그인 버튼의 고유 문자열 </b-input-group-text></b-input-group-prepend>
                  <b-form-input autocomplete="new-password" :disabled="lock" class="text-center border" type="text" v-model="opt_login.el_submit" :state="(opt_login.el_submit.length ? true : false)"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <hr>
      <template v-if="lock && !loading">
        <template>
          <b-button size="sm" variant="primary" @click="edit" class="btn-add"> 수정 </b-button>
          <b-button size="sm" variant="danger" @click="del_confirm = true"> 삭제 </b-button>
        </template>
      </template>
      <template v-if="!lock && !loading">
        <b-button size="sm" class="btn-add" variant="success" @click="() => model.id ? save() : modal_charge_agree = true"> 저장 </b-button>
        <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> 취소 </b-button>
      </template>
      <b-button v-if="!loading" size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>
    </b-tab>
  </b-tabs>
    <!-- delete modal -->
    <b-modal title="Delete"  class="modal-danger" v-model="del_confirm" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p> 등록 사이트 삭제 </p>
      <p>
        삭제하면 해당 사이트의 악성코드 배포 위치와 중단 여부를 확인할 수 없습니다.
      </p>
      <p> 삭제 하시겠습니까? </p>
      <p> <b> * 사이트 이름 확인 </b> </p>
      <p> 삭제할 사이트 이름 입력 : {{model.name}}  </p>
      <b-form-input v-model="del_nickname" placeholder="삭제할 서버의 이름을 입력합니다"></b-form-input>
    </b-modal>
    <!-- result modal -->
    <b-modal size="xl" title="최근 점검 결과"  class="modal-primary" v-model="confirm_result" hide-footer @ok="confirm_result = false" ok-variant="primary">
      <result :result_id="result.id" :site="model"></result>
    </b-modal>
    <!-- modal -->
    <b-modal size="xl" title="안내"  class="modal-info" v-model="modal_explain" hide-footer ok-variant="success">
      {{msg}}
    </b-modal>
    <b-modal v-model="modal_charge_agree" title="Controls all agents" @ok="charge_agree" no-close-on-backdrop header-bg-variant="warning">
      <h5>사이트 등록이 이루어지고 점검이 시작되면 과금이 시작됩니다.  </h5>
      <hr>
      <!-- <a target="_blank" :href="redir" class="card-link">
        <span class="text-dark">See More</span>
        <i class="fa fa-share"></i>
        {{redir}}
      </a> -->
      <hr>
      자세한 사항은 이용약관을 참조하시기 바랍니다.
      <h6> <b>적용 하시겠습니까 ?</b></h6>
    </b-modal>
    <b-modal v-model="opt_login.explain" title="Login Option Explain" @ok="opt_login.modal_explain = false" no-close-on-backdrop header-bg-variant="info">
      <h6>
        로그인이 필요한 사이트의 경우 점검 시 계정 로그인을 통해 로그인이 필요한 사이트를 확인할 수 있는 점검계좌를 발급한다.
      </h6>
    </b-modal>
    <b-modal v-model="opt_login.modal_props" title="Choice unique string of tag property" @ok="opt_login.modal_props = false" no-close-on-backdrop header-bg-variant="info" hide-footer>
      <h6>
        <b-form-group>

          <table class="table table-sm">
            <th>번호</th>
            <th>고유 문자열</th>
            <tr v-for="(item, index) in opt_login.props" :key="'_probs_'+index">
                <td> {{ index + 1 }} </td>
                <td>
                  <b-form-radio v-model="opt_login.sel_props" name="props" :value="item"> {{ item }} </b-form-radio>
                </td>
            </tr>
            <tr v-if="!opt_login.props">
              <td colspan="2"> 정보가 없습니다 </td>
            </tr>
          </table>
          <hr class="w-100">
          <b-button block class="btn-add" :disabled="!opt_login.props" size="sm" variant="success" @click="opt_login_select()"> 다음 </b-button>
        </b-form-group>
      </h6>
      <hr>
    </b-modal>
  </div>
</template>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
